// src/components/ToastContainer.js
import React from "react";
import Toast from "./Toast";
import "./Toast.css";

/**
 * Container component to manage multiple toast notifications
 * Usage: Add <ToastContainer toasts={toasts} onRemove={handleRemove} /> to your app
 */
export default function ToastContainer({ toasts = [], onRemove }) {
  if (!toasts || toasts.length === 0) return null;

  return (
    <div className="toast-container">
      {toasts.map((toast, index) => (
        <Toast
          key={toast.id || index}
          message={toast.message}
          type={toast.type || "success"}
          duration={toast.duration !== undefined ? toast.duration : 3000}
          show={true}
          onClose={() => onRemove && onRemove(toast.id || index)}
        />
      ))}
    </div>
  );
}

